export class RemoveDailyAttendanceEvent {
    id = 0;

    name = 'Clear';

    isRemove = true;
}
